<template>
  <div>
    <b-table
      :data="data"
      :loading="isLoading"
      paginated
      backend-pagination
      :total="total"
      :per-page="perPage"
      :striped="true"
      :hoverable="true"
      :current-page="currentPage"
      @page-change="onPageChange"
      default-sort="total"
      default-sort-direction="desc">

      <template slot-scope="props">
        <b-table-column class="has-no-head-mobile is-image-cell">
        </b-table-column>
        <b-table-column label="DNI" field="name" sortable>
          {{ props.row.dni }}
        </b-table-column>
        <b-table-column label="Codigo Colaborador" field="name" sortable>
          {{ props.row.external_id }}
        </b-table-column>
        <b-table-column label="Fecha y Hora" field="date" sortable>
          {{ parseDate(props.row.date) }}
        </b-table-column>
        <b-table-column label="Respuesta" field="response" sortable>
          {{ props.row.status }}
        </b-table-column>
      </template>

      <section class="section" slot="empty">
        <div class="content has-text-grey has-text-centered">
          <template v-if="isLoading">
            <p>
              <b-icon icon="dots-horizontal" size="is-large"/>
            </p>
            <p>Cargando Data...</p>
          </template>
          <template v-else>
            <p>
              <b-icon icon="emoticon-sad" size="is-large"/>
            </p>
            <p>No hay data :/&hellip;</p>
          </template>
        </div>
      </section>
    </b-table>
  </div>
</template>

<script>

export default {
  name: 'HistoricalTable',
  props: {
    isLoading: {
      type: Boolean,
      default: false
    },
    perPage: {
      type: Number,
      default: 100
    },
    currentPage: {
      type: Number,
      default: 100
    },
    total: {
      type: Number,
      default: 1000
    },
    data: {
      type: Array,
      default: null
    },
    method: {
      type: Function
    }
  },
  methods: {
    onPageChange (page) {
      this.$emit('page-change', page)
    },
    parseDate: function (mdate) {
      const datetime = new Date(mdate)
      const dateTimeFormat = datetime.getUTCDate() + '/' + (datetime.getUTCMonth() + 1) + '/' + datetime.getUTCFullYear() + ' ' + datetime.getUTCHours() + ':' + (datetime.getUTCMinutes() + 1)
      return dateTimeFormat
    }
  }
}
</script>
